// Sticky header widget
$(document).ready(function() {
	/* simple scroll check */
    $(window).scroll(function() {
		var staticHeader 	= $("#staticHeader").outerHeight();
		var scrollTop 		= $(window).scrollTop();
		/* simple collision check */
		scrollTop >= staticHeader ? $("#stickyHeader").addClass("stickIt") : $("#stickyHeader").removeClass("stickIt");
		scrollTop >= staticHeader ? $("body").addClass("sticky") : $("body").removeClass("sticky");
	});
});